<script>
  import AdGroupForm from './AdGroupForm.vue'
  import BannerPosition from './BannerPosition.vue'
  import { getBannerTemList } from '@/api/bottomBannerDefault/index'

  export default {
    name: 'AdGroupSimpleEditor',
    components: {
      AdGroupForm,
      BannerPosition
    },
    props: {
      // 编辑数据
      currentAdGroup: {
        type: Object,
        default: () => null
      },
      // 是否编辑模式
      isEdit: {
        type: Boolean,
        default: false
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data() {
      return {
        form: {
          name: '',
          adTemplateId: '',
          sort: 0,
          adTemplateName: '',
          slotKeys: [],
          startTime: '',
          endTime: '',
          allArea: 1,
          areaIdList: [],
          displayChannelList: []
        },
        slotKeys: [],
        defaultBanners: [],
        isLoading: false,
        bannerTemplates: []
      }
    },
    created() {
      this.fetchBannerTemplates()
    },
    methods: {
      // 获取banner模板列表
      fetchBannerTemplates() {
        getBannerTemList().then((res) => {
          const { code, data } = res
          if (code === 0) {
            this.bannerTemplates = data || []
            this.initData()
          }
        })
      },
      // 初始化数据
      async initData() {
        if (this.currentAdGroup) {
          // bannerList
          const { adGroup, bannerList } = this.currentAdGroup
          this.form = { ...adGroup }
          console.log('adGroup', adGroup, this.currentAdGroup)
          const { templateId } = adGroup
          const temItem = this.bannerTemplates.find((item) => item.id === templateId)
          if (temItem) {
            this.slotKeys = temItem.slotKeys || []
            this.defaultBanners = bannerList
            this.$set(this.form, 'slotKey', this.slotKeys[0])
          }
        }
      },

      // 处理模板变更
      handleTemplateChange({ slotKeys }) {
        this.slotKeys = slotKeys || []

        // 设置第一个位置为激活状态
        if (this.slotKeys && this.slotKeys.length > 0) {
          this.form.slotKey = this.slotKeys[0]

          // 通知BannerPosition组件更新当前位置
          this.$nextTick(() => {
            if (this.$refs.bannerPosition) {
              this.$refs.bannerPosition.updateCurrentPosition(this.slotKeys[0])
            }
          })
        }
      },

      // 处理表单变更
      handleFormChange(formData) {
        this.form = { ...this.form, ...formData }
        this.$emit('change', this.form)
      },

      // 处理banner位置变更
      handleBannerPositionChange(data) {
        if (data && data.slotKey) {
          this.form.slotKey = data.slotKey
          this.$emit('change', this.form)
        }
      },

      // 校验表单
      async validate() {
        // 1. 校验基本表单
        const basicFormData = await this.$refs.adGroupForm.validate()
        // 2. 校验banner位置表单
        const bannerPositionData = await this.$refs.bannerPosition.validateAllForms(this.slotKeys)
        // 3. 合并数据并返回
        return {
          ...basicFormData,
          ...bannerPositionData
        }
      },

      // 获取表单数据（不校验）
      getData() {
        const basicFormData = { ...this.form }
        const bannerPositionData = this.$refs.bannerPosition.getAllData()

        return {
          ...basicFormData,
          ...bannerPositionData
        }
      }
    }
  }
</script>

<template>
  <div class="ad-group-simple-editor">
    <!-- 基本信息表单 -->
    <AdGroupForm
      ref="adGroupForm"
      v-model="form"
      :is-edit="isEdit"
      :is-simple-mode="true"
      @template-change="handleTemplateChange"
      @change="handleFormChange"
      :banner-templates="bannerTemplates"
    />

    <!-- Banner位置配置 -->
    <BannerPosition
      ref="bannerPosition"
      v-model="form"
      :slot-keys="slotKeys"
      :is-edit="isEdit"
      :is-simple-mode="true"
      :default-banners="defaultBanners"
      @change="handleBannerPositionChange"
    />
  </div>
</template>

<style scoped lang="scss">
  .ad-group-simple-editor {
    padding: 10px;
  }
</style>
